import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Menu, MenuItem, MenuProps, MenuValue } from "../menu";

type SelectMenuProps<V extends MenuValue, T extends MenuItem<V>> = Omit<
  MenuProps<V, T>,
  "error" | "setValue" | "selectedValue"
>;

export const SelectMenu = <V extends MenuValue, T extends MenuItem<V>>({
  children,
  name,
  ...menuProps
}: SelectMenuProps<V, T>): React.ReactElement => {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value }, fieldState: { error } }) => (
        <Menu
          name={name}
          error={error?.message ?? undefined}
          setValue={setValue}
          selectedValue={value as V}
          {...menuProps}
        >
          {children}
        </Menu>
      )}
    />
  );
};
